import { useQuery } from '@tanstack/react-query';
import { makeCRMApi } from '../CrmApi';
import { AxiosError, AxiosResponse } from 'axios';
import { ICrmSearchTagsRequest, ICrmSearchTagGroup } from '../types/CrmTagTypes';

export const useCrmTags = (request: ICrmSearchTagsRequest, enabled?: boolean) => {
  const crmApi = makeCRMApi();

  const crmTags = useQuery<AxiosResponse<ICrmSearchTagGroup[]>, AxiosError>({
    queryKey: ['crm-tags', request],
    queryFn: () => {
      return crmApi.searchTags(request);
    },
    retry: false,
    enabled: enabled !== false,
  });

  return {
    crmTags,
  };
};
